import {
  FETCH_PURCHASE_ORDER_LIST_FILTER,
  RESET_PURCHASE_ORDER_LIST_FILTER,
  FETCH_PURCHASE_ORDER_LIST_CHIP_FILTER,
} from "../../constants/action.constants";

const initialState = {
  filters: {},
  chipFilters: [],
};

const purchaseOrderListFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_ORDER_LIST_FILTER:
      return {
        ...state,
        filters: action.payload,
      };

    case FETCH_PURCHASE_ORDER_LIST_CHIP_FILTER:
      return {
        ...state,
        chipFilters: action.payload,
      };

    case RESET_PURCHASE_ORDER_LIST_FILTER:
      return initialState;

    default:
      return state;
  }
};

export default purchaseOrderListFilterReducer;
